import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useIdleTimer } from 'react-idle-timer';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import { I18NextNS } from 'src/models/Language.model';

// 60m
const timeout = 1000 * 60 * 60;
// 30s
const promptBeforeIdle = 1000 * 30;

export default function CustomIdleTimer() {
  const [remaining, setRemaining] = useState<number>(timeout);
  const [open, setOpen] = useState<boolean>(false);

  const { logOut } = useRemoteBoundStore();

  const onIdle = () => {
    setOpen(false);
    logOut();
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const handleStillHere = () => {
    activate();
  };

  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModal show={open}>
      <Modal.Header>
        <Modal.Title>{t('loginLogout.idleTimer.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('loginLogout.idleTimer.desc', { remaining })}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleStillHere}>
          {t('loginLogout.idleTimer.keepMeLoggedIn')}
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
